import React from 'react'
import { useParams } from 'react-router-dom';
import { isEmptyString } from '../../helperFunc';
import { useGetAllSpwsForSearchCatalogueQuery } from '../../redux/searchService';
import SpwFilterData from '../SpwFilter/SpwFilterData';
import { useSelector } from 'react-redux';

function SearchSpwFIlter() {
  // const { relCatName } = useParams();
  const {urlRelName } = useSelector((state) => state.router);
  const { currentData: SPWData, isFetching } = useGetAllSpwsForSearchCatalogueQuery(urlRelName, { skip: isEmptyString(urlRelName) });

  return (
    <div>
      <SpwFilterData SPWData={SPWData} isFetching={isFetching} />
    </div>
  );
}

export default SearchSpwFIlter